import { RoutingPath } from "src/app/configs/routing-path";

export interface Request {
  type: any;
  title: string;
  subtitle?: string;
  body: string;
  footer?: string;
}

export enum TypeQueryWorker {
  AFFILIATIONS,
  RETREAT,
  QUERYWORKER,
  CERTIFIED,
  MONETARYFEE
}

export enum StatusRequest {
  preceso = 1,
  rechazado = 2,
  aceptado = 3,
}

export enum TypeComplementEnum {
	ACREDITACION_CUOTA_MONETARIA = 1,
	DISCAPACIDAD = 2,
}


export class RedirecTOURL {
  public static Proccess = [
      { urlProcess: RoutingPath.appRouting.components.invidivual_affiliation.path + '/'
        + RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path,
        urlFormExito: RoutingPath.appRouting.components.invidivual_affiliation.path + '/'
        + RoutingPath.appRouting.components.invidivual_affiliation.pages.affiliation_form.path,
        urlNotFound: RoutingPath.appRouting.components.invidivual_affiliation.path + '/' + RoutingPath.appRouting.components.invidivual_affiliation.pages.error_affiliation.path},
      /*{ urlProcess: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.individual_retreat.pages.home.path,
        urlFormExito: RoutingPath.appRouting.components.workers_information.path + '/'
           + RoutingPath.appRouting.components.workers_information.pages.query_result.path,
        urlNotFound: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.invidivual_affiliation.pages.error_affiliation.path}*/
      { urlProcess: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.individual_retreat.pages.home.path,
        urlFormExito: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.individual_retreat.pages.perfil_worker.path,
        urlNotFound: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.invidivual_affiliation.pages.error_affiliation.path}
  ]
}




/**
 * { urlProcess: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.individual_retreat.pages.home.path,
        urlFormExito: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.individual_retreat.pages.retreat_form.path,
        urlNotFound: RoutingPath.appRouting.components.individual_retreat.path + '/'
        + RoutingPath.appRouting.components.invidivual_affiliation.pages.error_affiliation.path}
 *
 */
